module.exports = __webpack_public_path__ + "img/big_ico_app@2x.c01089b3.png";